
@if (fetchingResults) {
  <p style="text-align:center">
    <mat-spinner style="margin:0 auto;"  [diameter]="40"></mat-spinner>
  </p>
}
<!--
<div *ngIf="cars == undefined || cars.length == 0">
  Aucun véhicule
</div> -->

<h6> <b>{{ cars.length }} véhicules </b> en <b> {{ businessLine == CarBusinessLine.BUY ? 'vente' : 'location' }} </b> pour votre recherche</h6>

@if (!fetchingResults) {
  <div class="car-list">
    <!--
    <app-car-card-horizontal *ngFor="let car of cars ; index as i"
      [businessLine]= businessLine!
      [car]="car"
      [isSeller]="((currentUserId$ | async)! === car.providerId)"
      [carImagesFolder]="(carImagesFolders$ | async)!.get(car.carId)!">
    </app-car-card-horizontal>  -->
    @for (car of cars ; track car; let i = $index) {
      <app-car-card-horizontal
        [businessLine]= businessLine!
        [car]="car"
        [isProvider]="((currentUserId$ | async)! === car.providerId)"
        [loggedInUser]="((currentUser$ | async)!)"
        [carImagesFolder]="(carImagesFolders$ | async)!.get(car.carId)!">
      </app-car-card-horizontal>
    }
  </div>
}





